import { useAuth } from "@/contexts/AuthContext";

export function getRoleBasedPath(roles: string[]): string {
  if (roles.includes("super_admin")) return "/admin";
  if (roles.includes("accountant")) return "/accountant";
  if (roles.includes("support") || roles.includes("call_center")) return "/support-panel";
  if (roles.includes("parent") && !roles.includes("admin") && !roles.includes("teacher")) return "/dashboard/parent";
  return "/dashboard";
}

export function useRoleRedirect() {
  const { roles } = useAuth();
  return getRoleBasedPath(roles);
}
